import _slicedToArray from "/builds/1TgzPVrG/0/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React, { useState } from "react";
import Accordion from "../../Accordion";
import * as S from "./styles";
var TOGGLE_LIMIT = 188;
export function Product(_ref) {
  var e = _ref.product,
      t = _ref.truncationStrategy,
      r = _ref.sanitationStrategy;
  var c, a, l, n;

  var _useState = useState(!1),
      _useState2 = _slicedToArray(_useState, 2),
      o = _useState2[0],
      i = _useState2[1],
      d = (null === (c = null == e ? void 0 : e.markerList) || void 0 === c ? void 0 : c.markers) || [],
      u = null === (a = null == e ? void 0 : e.longDescription) || void 0 === a ? void 0 : a.longDescription,
      p = null === (n = null === (l = null == e ? void 0 : e.productCardImage) || void 0 === l ? void 0 : l.fluid) || void 0 === n ? void 0 : n.src;

  return React.createElement(React.Fragment, null, React.createElement(S.ProductWrapper, {
    key: e.id
  }, React.createElement(S.ProductImageWrapper, null, React.createElement(S.ProductImage, {
    src: p,
    alt: e.displayName,
    fadeIn: !1
  })), React.createElement(S.ProductInfoWrapper, null, React.createElement(S.ProductTitle, null, e.displayName), e.price && React.createElement(S.ProductTitle, null, "$", e.price), React.createElement(S.ProductDescription, null, React.createElement(S.ProductTruncatedDescription, {
    "data-testid": "product-description"
  }, t ? o ? u : t(u) : u), t && 188 < (null == u ? void 0 : u.length) && React.createElement(S.ProductDescriptionToggle, {
    onClick: function onClick() {
      return i(function (e) {
        return !e;
      });
    },
    "data-testid": "product-description-toggle"
  }, o ? "Hide Less" : "Show More"), e.detailsComponent))), React.createElement(Accordion.Wrapper, {
    allowMultipleOpened: !0
  }, d.length > 0 && React.createElement(S.AccordionItemWrapper, {
    hasBorderTop: !0
  }, React.createElement(Accordion.Item, null, React.createElement(S.AccordionHeading, null, "What's Measured"), React.createElement(Accordion.Child, null, d.map(function (_ref2, c) {
    var e = _ref2.title,
        t = _ref2.description;
    return React.createElement(S.MarkerWrapper, {
      key: c
    }, React.createElement(S.MarkerTitle, null, e), t && t.hasOwnProperty("description") && r && React.createElement(S.MarkerDescription, {
      dangerouslySetInnerHTML: {
        __html: r(null == t ? void 0 : t.description)
      }
    }));
  }))))));
}
export default Product;